import { createSlice } from '@reduxjs/toolkit';

import {
  createAdminCashExchange,
  getAdminEditCashExchange,
  getAdminCashExchanges,
  updateAdminCashExchange,
} from './adminCashExchange.actions';

const initialState = {
  cashExchanges: [],
  cashExchangesMeta: {},
  isLoadingCashExchanges: false,

  selectedCashExchange: {},
  isLoadingCashExchange: false,

  errors: {},
};

const adminExchangesSlice = createSlice({
  name: 'adminExchanges',
  initialState,
  reducers: {
    setAdminCashExchangesMeta: (state, action) => {
      state.cashExchangesMeta = action.payload;
    },
    setSelectedCashExchange: (state, action) => {
      state.selectedCashExchange = action.payload;
    },
    setAdminCashExchangeErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminCashExchanges.pending, (state) => {
      state.isLoadingCashExchanges = true;
    });
    builder.addCase(getAdminCashExchanges.fulfilled, (state, action) => {
      state.cashExchanges = action.payload;
      state.isLoadingCashExchanges = false;
    });
    builder.addCase(getAdminCashExchanges.rejected, (state) => {
      state.isLoadingCashExchanges = false;
    });

    builder.addCase(createAdminCashExchange.pending, (state) => {
      state.isLoadingCashExchange = true;
    });
    builder.addCase(createAdminCashExchange.fulfilled, (state) => {
      state.isLoadingCashExchange = false;
    });
    builder.addCase(createAdminCashExchange.rejected, (state) => {
      state.isLoadingCashExchange = false;
    });

    builder.addCase(getAdminEditCashExchange.pending, (state) => {
      state.isLoadingCashExchange = true;
    });
    builder.addCase(getAdminEditCashExchange.fulfilled, (state, action) => {
      state.selectedCashExchange = action.payload;
      state.isLoadingCashExchange = false;
    });
    builder.addCase(getAdminEditCashExchange.rejected, (state) => {
      state.isLoadingCashExchange = false;
    });

    builder.addCase(updateAdminCashExchange.pending, (state) => {
      state.isLoadingCashExchange = true;
    });
    builder.addCase(updateAdminCashExchange.fulfilled, (state) => {
      state.isLoadingCashExchange = false;
    });
    builder.addCase(updateAdminCashExchange.rejected, (state) => {
      state.isLoadingCashExchange = false;
    });
  },
});

export const { setAdminCashExchangesMeta, setSelectedCashExchange, setAdminCashExchangeErrors } =
  adminExchangesSlice.actions;

export default adminExchangesSlice.reducer;
